import content from "@/content/site-content.json";
import type { SiteContent } from "@/types/content";

const { footer } = content as SiteContent;

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div>
          <p className="site-footer__name">{footer.orgName}</p>
          <p className="site-footer__meta">{footer.orgNumber}</p>
        </div>
        <div className="site-footer__links">
          <a href={`mailto:${footer.email}`}>{footer.email}</a>
          {footer.socials.map((s) => (
            <a key={s.href} href={s.href} target="_blank" rel="noreferrer">
              {s.label}
            </a>
          ))}
        </div>
      </div>
      <style>{`
        .site-footer {
          background: var(--color-ink);
          color: var(--color-apricot);
          padding: var(--space-3) 0;
        }
        .site-footer__inner {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: var(--space-2);
        }
        .site-footer__name {
          font-family: var(--font-display);
          text-transform: uppercase;
          letter-spacing: var(--tracking-wordmark);
          margin: 0;
          color: #fff;
        }
        .site-footer__meta {
          margin: 0.2rem 0 0;
          font-size: 0.85rem;
          opacity: 0.8;
        }
        .site-footer__links {
          display: flex;
          gap: var(--space-2);
          flex-wrap: wrap;
        }
        .site-footer__links a {
          color: var(--color-apricot);
          text-decoration: none;
          font-size: 0.9rem;
        }
        .site-footer__links a:hover {
          text-decoration: underline;
        }
      `}</style>
    </footer>
  );
}
